<template>
	<div class="form">
		<div class="form-item">
			<div class="form-item-main">
				<div class="label">手机号：</div>
				<van-field center disabled v-model="formdata.phone" placeholder="请输入手机号" />
			</div>
		</div>
		<div class="form-item">
			<div class="form-item-main">
				<div class="label">获取验证码：</div>
				<van-field center clearable v-model="formdata.sms" placeholder="请输入验证码">
					  <template #button>
					    <van-button @click="sendSms(formdata.phone,1)" v-if="!isSms" size="small">发送验证码</van-button>
					    <van-button class="btn-no" size="small" v-else>{{second}}s</van-button>
					  </template>
				</van-field>
			</div>
			<div class="error" v-if="errors.sms">{{ errors.sms }}</div>
		</div>
		<div class="form-item">
			<div class="form-item-main">
				<div class="label">新手机号：</div>
				<van-field center clearable v-model="formdata2.phone" placeholder="请输入手机号" />
			</div>
			<div class="error" v-if="errors2.phone">{{ errors2.phone }}</div>
		</div>
		<div class="form-item">
			<div class="form-item-main">
				<div class="label">获取验证码：</div>
				<van-field center clearable v-model="formdata2.sms" placeholder="请输入验证码">
					  <template #button>
					    <van-button @click="sendSms(formdata2.phone,2)" v-if="!isSms2" size="small">发送验证码</van-button>
					    <van-button class="btn-no" size="small" v-else>{{second2}}s</van-button>
					  </template>
				</van-field>
			</div>
			<div class="error" v-if="errors2.sms">{{ errors2.sms }}</div>
		</div>
		<van-button class="submit" @click="submit" size="large">提交</van-button>
	</div>
</template>

<script>
export default {
	name: 'index',
	data(){
		return {
			formdata:{
				phone:"",
				sms:"",
			},
			formdata2:{
				phone:"",
				sms:"",
			},
			errors: {
				phone: '',
				sms: '',
			},
			errors2: {
				phone: '',
				sms: '',
			},
			isSms:false,
			second:60,
			isSms2:false,
			second2:60,
		}
	},

	created(){
		this.formdata.phone = JSON.parse(localStorage.getItem('userInfo')).accountCode
		console.dir(JSON.parse(localStorage.getItem('userInfo')))
	},
	mounted() {

	},

	computed: {

	},
	watch: {

	},
	methods: {
		async sendSms(accountCode,t) {
			try {
				const response = await this.$api.sendSms({ accountCode });
		
				if (response.data.success) {
					this.$message.success("验证码已发送");
					if(t==1){
						this.isSms = true;
						this.startCountdown();
					}else{
						this.isSms2 = true;
						this.startCountdown2();
					}
				} else {
					this.$message.error(response.data.message || "发送验证码失败");
				}
			} catch (error) {
				this.$message.error("发送失败，请重试");
			}
		},
		startCountdown() {
			this.second = 60;
			const countdown = setInterval(() => {
				if (this.second > 0) {
					this.second -= 1;
				} else {
					this.isSms = false;
					clearInterval(countdown);
				}
			}, 1000);
		},
		startCountdown2() {
			this.second2 = 60;
			const countdown2 = setInterval(() => {
				if (this.second2 > 0) {
					this.second2 -= 1;
				} else {
					this.isSms2 = false;
					clearInterval(countdown2);
				}
			}, 1000);
		},
		validateForm(formdata) {
			// 重置错误信息
			this.errors = {
				phone: '',
				sms: ''
			};
		
			let valid = true;
		
			// 手机号校验：11位数字，符合中国手机号格式
			const phoneRegex = /^1[3-9]\d{9}$/;
			if (!formdata.phone) {
				this.errors.phone = '手机号不能为空';
				valid = false;
			} else if (!phoneRegex.test(formdata.phone)) {
				this.errors.phone = '手机号格式不正确';
				valid = false;
			}
		
			// 验证码校验：4位数字
			const codeRegex = /^\d{4}$/;
			console.dir(formdata)
			if (!formdata.sms) {
				this.errors.sms = '验证码不能为空';
				valid = false;
			} else if (!codeRegex.test(formdata.sms)) {
				this.errors.sms = '验证码必须是4位数字';
				valid = false;
			}
		
			if (valid) {
				return true
			} else {
				return false
			}
		},
		validateForm2(formdata) {
			// 重置错误信息
			this.errors2 = {
				phone: '',
				sms: ''
			};
		
			let valid = true;
		
			// 手机号校验：11位数字，符合中国手机号格式
			const phoneRegex = /^1[3-9]\d{9}$/;
			if (!formdata.phone) {
				this.errors2.phone = '手机号不能为空';
				valid = false;
			} else if (!phoneRegex.test(formdata.phone)) {
				this.errors2.phone = '手机号格式不正确';
				valid = false;
			}
		
			// 验证码校验：4位数字
			const codeRegex = /^\d{4}$/;
			if (!formdata.sms) {
				this.errors2.sms = '验证码不能为空';
				valid = false;
			} else if (!codeRegex.test(formdata.sms)) {
				this.errors2.sms = '验证码必须是4位数字';
				valid = false;
			}
		
			if (valid) {
				return true
			} else {
				return false
			}
		},
		async submit() {//绑定新手机号
			if(!this.validateForm(this.formdata)||!this.validateForm2(this.formdata2)){
				return;
			}

			let jsondata = {
				oldAccountCode: this.formdata.phone,
				oldVerifyCode: this.formdata.sms,
				newAccountCode: this.formdata2.phone,
				newVerifyCode: this.formdata2.sms
			};
			const res = await this.$api.updateAccount(jsondata);
			if (res.data.success) {
				this.$message.success("修改成功")
				localStorage.removeItem("userInfo");
				localStorage.removeItem("userCode");
				this.$router.replace({ path: '/' });
			}else{
				this.$message.error(res.data.errMsg||res.data.error||res.data.msg||res.data.message);
			}
		},
	}
}
</script>

<style lang="scss" scoped>
	.form{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		height: 100%;
		.form-item{
			margin-bottom: 1rem;
			.form-item-main{
				display: flex;
				align-items: center;
			}
			.label{
				width: 8rem;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-size: 1.2rem;
				color: #282D30;
				line-height: 1.41rem;
				text-align: right;
				margin-right: 1.5rem;
			}
			.van-cell{
				width: 28.6rem;
				height: 3.1rem;
				border-radius: 0.25rem 0.25rem 0.25rem 0.25rem;
				border: 0.05rem solid #E0E0E0;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-size: 1.2rem;
				line-height: 2.1rem;
			}
			.van-button{
				width: 7rem;
				height: 1.85rem;
				background: rgb(100, 45, 113);
				border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-size: 1rem;
				color: #FFFFFF;
				line-height: 1.85rem;
				text-align: center;
			}
			::v-deep .van-field__button{
				display: flex;
			}
		}
		.submit{
			width: 8.4rem;
			height: 2.9rem;
			background: rgb(100, 45, 113);
			border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
			font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
			font-weight: 500;
			font-size: 1.4rem;
			color: #FFFFFF;
			line-height: 2.9rem;
			text-align: center;
			margin-top: 1rem;
		}
	}
	.error {
	  color: red;
	  font-size: 1.2rem;
		width: 18.5rem;
		margin-left: 9.5rem;
		margin-top: 0.5rem;
	}
</style>